import type { CryptoWhitelistedAddress } from "~/v2/api/rest/cryptoWallet";

export type WhitelistAddressStep = "assetAddress" | "travelRule";

export const BENEFICIARY_TYPES = ["individual", "business"] as const;

export type BeneficiaryType = (typeof BENEFICIARY_TYPES)[number];

export const BENEFICIARY_TYPE_OPTIONS: {
  value: BeneficiaryType;
  label: string;
}[] = [
  { value: "individual", label: "Individual" },
  { value: "business", label: "Business / Organization" },
];

export interface AssetAddressData {
  chain: string;
  asset: string;
  address: string;
}

export interface AssetAddressDisplay {
  chainCode: string;
  chainLabel: string;
  assetCode: string;
  assetLabel: string;
}

export type WhitelistAddressMode =
  | { kind: "create" }
  | { kind: "edit"; whitelistId: string; existing: CryptoWhitelistedAddress };
